/**
 * Кодирование в Windows-1251 (CP1251).
 *
 * Нужно в двух местах: XML УПД по требованию ФНС передаётся именно в этой
 * кодировке (см. CLAUDE.md), и банковский QR для оплаты (ГОСТ Р 56042-2014)
 * читается банковскими приложениями тоже как CP1251, а не UTF-8 — если
 * закодировать кириллицу как UTF-8, приложение покажет вместо текста «кракозябры».
 *
 * Таблица байтов 0x80-0xFF — из самого стандарта codepage 1251. Символы заданы
 * кодами \uXXXX, а не литералами кириллицы: визуально похожие буквы (например
 * «і» украинское и «i» латинское) легко перепутать при наборе, а тут это
 * реальная таблица кодировки — опечатка испортит любой текст с этим байтом.
 */
/** Байты 0x80-0x9F. -1 — байт 0x98 в CP1251 не назначен. */
const RANGE_80_9F = [
    0x0402, 0x0403, 0x201a, 0x0453, 0x201e, 0x2026, 0x2020, 0x2021,
    0x20ac, 0x2030, 0x0409, 0x2039, 0x040a, 0x040c, 0x040b, 0x040f,
    0x0452, 0x2018, 0x2019, 0x201c, 0x201d, 0x2022, 0x2013, 0x2014,
    -1, 0x2122, 0x0459, 0x203a, 0x045a, 0x045c, 0x045b, 0x045f,
];
/** Байты 0xA0-0xBF. */
const RANGE_A0_BF = [
    0x00a0, 0x040e, 0x045e, 0x0408, 0x00a4, 0x0490, 0x00a6, 0x00a7,
    0x0401, 0x00a9, 0x0404, 0x00ab, 0x00ac, 0x00ad, 0x00ae, 0x0407,
    0x00b0, 0x00b1, 0x0406, 0x0456, 0x0491, 0x00b5, 0x00b6, 0x00b7,
    0x0451, 0x2116, 0x0454, 0x00bb, 0x0458, 0x0405, 0x0455, 0x0457,
];
// А-Я — 0xC0-0xDF, а-я — 0xE0-0xFF.
const CYRILLIC_UPPER_START = 0x0410;
const CYRILLIC_LOWER_START = 0x0430;
const charToByte = new Map();
for (let byte = 0; byte < 0x80; byte += 1) {
    charToByte.set(String.fromCharCode(byte), byte);
}
RANGE_80_9F.forEach((codePoint, i) => {
    if (codePoint >= 0)
        charToByte.set(String.fromCharCode(codePoint), 0x80 + i);
});
RANGE_A0_BF.forEach((codePoint, i) => {
    charToByte.set(String.fromCharCode(codePoint), 0xa0 + i);
});
for (let i = 0; i < 0x20; i += 1) {
    charToByte.set(String.fromCharCode(CYRILLIC_UPPER_START + i), 0xc0 + i);
    charToByte.set(String.fromCharCode(CYRILLIC_LOWER_START + i), 0xe0 + i);
}
/**
 * Строка → байты CP1251. Символ, которого нет в таблице (иероглифы, эмодзи
 * и т.п.), заменяется на «?» — падать из-за одного неподходящего символа
 * в адресе или названии не нужно.
 */
export function encodeCp1251(text) {
    const bytes = new Uint8Array(text.length);
    for (let i = 0; i < text.length; i += 1) {
        bytes[i] = charToByte.get(text[i]) ?? 0x3f;
    }
    return bytes;
}
//# sourceMappingURL=cp1251.js.map